import { sectionRenderer } from '@theme/section-renderer';

const groups = new Set(['all', 'models', 'sets', 'details', 'equipment', 'storage', 'street']);
const activeGroup = () => groups.has(location.hash.slice(1)) ? location.hash.slice(1) : 'all';
function refresh() {
  document.querySelectorAll('[data-md-shop-navigation]').forEach((nav) => {
    const root = nav.closest('results-list');
    if (!root) return;
    const group = activeGroup();
    const links = [...nav.querySelectorAll('[data-md-browse]')];
    const selected = links.find((link) => link.dataset.mdBrowse === group);
    const title = nav.querySelector('[data-md-browse-title]');
    if (!title.dataset.mdOriginalTitle) title.dataset.mdOriginalTitle = title.textContent;
    const label = selected?.dataset.mdLabel || nav.dataset[group];
    title.textContent = group === 'all' ? title.dataset.mdOriginalTitle : `${title.dataset.mdOriginalTitle} — ${label}`;
    links.forEach((link) => {
      if (link.dataset.mdBrowse === group && nav.dataset.mdLegacy !== 'true') link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
    root.querySelectorAll('facet-remove-component[data-url]').forEach((removal) => {
      try {
        const url = new URL(removal.dataset.url, location.href);
        url.hash = groups.has(location.hash.slice(1)) ? location.hash : '';
        removal.dataset.url = url.toString();
      } catch {}
    });
    let visible = 0;
    root.querySelectorAll('[data-md-categories]').forEach((card) => {
      card.hidden = group !== 'all' && !card.dataset.mdCategories.trim().split(/\s+/).includes(group);
      if (!card.hidden) visible++;
    });
    const count = nav.querySelector('[data-md-browse-count]');
    const status = count.parentElement;
    status?.setAttribute('role', 'status');
    status?.setAttribute('aria-live', 'polite');
    status?.setAttribute('aria-atomic', 'true');
    if (count.textContent !== String(visible)) count.textContent = String(visible);
    root.querySelectorAll('.products-count-wrapper').forEach((nativeCount) => {
      nativeCount.hidden = group !== 'all';
      if (group !== 'all') nativeCount.style.setProperty('display', 'none', 'important');
      else nativeCount.style.removeProperty('display');
    });
    root.querySelectorAll('.facets__see-results').forEach((button) => {
      const label = button.textContent.replace(/\d+/, String(visible)).replace(/\bitems?\b/, visible === 1 ? 'item' : 'items');
      if (button.textContent !== label) button.textContent = label;
    });
  });
}
let queued = false;
const schedule = () => {
  if (queued) return;
  queued = true;
  queueMicrotask(() => { queued = false; refresh(); });
};
new MutationObserver((changes) => {
  if (changes.some((change) => [...change.addedNodes].some((node) => node.nodeType === 1))) schedule();
}).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
window.addEventListener('hashchange', refresh);
// Native filtering morphs existing attributes/text without necessarily adding nodes.
// Wait for its documented completion promise before applying the local grouping.
const serverURL = () => { const url = new URL(location.href); return url.pathname + url.search; };
let renderedURL = serverURL();
let historyRevision = 0;
document.addEventListener('shopify:collection:update', (event) => {
  const root = event.target.closest?.('results-list');
  if (!root?.querySelector('[data-md-shop-navigation]')) return;
  renderedURL = serverURL();
  const revision = ++historyRevision;
  Promise.resolve(event.promise).then(() => {
    if (revision === historyRevision) refresh();
  }).catch((error) => {
    if (revision === historyRevision) renderedURL = null;
    console.warn('Catalogue filter refresh failed', error);
  });
});
window.addEventListener('popstate', () => {
  refresh();
  const requestedURL = serverURL();
  if (requestedURL === renderedURL) return; // Hash-only category navigation needs no fetch.
  renderedURL = requestedURL;
  const revision = ++historyRevision;
  document.querySelectorAll('[data-md-shop-navigation]').forEach((nav) => {
    const root = nav.closest('results-list');
    const sectionId = root?.getAttribute('section-id');
    if (!sectionId) return;
    // Reuse the theme's cancellation/morph machinery; never push a new history entry.
    sectionRenderer.renderSection(sectionId, {
      url: new URL(location.href),
      shouldRender: () => revision === historyRevision && requestedURL === serverURL(),
    }).then(() => {
      if (revision === historyRevision) refresh();
    }).catch((error) => {
      if (revision === historyRevision) renderedURL = null;
      console.warn('Catalogue history refresh failed', error);
    });
  });
});
document.addEventListener('shopify:section:load', refresh);
refresh();

